export default __webpack_public_path__ + "assets/images/8699cae7270c90a930b6508e7610887e.svg";